import comp from "./ProfileAvtar";
export default comp;
